// ru.js
import elementLocale from 'element-ui/lib/locale/lang/en' // 用英文作基础

export default {
  ...elementLocale,
  menu: {
    home: 'Главная',
    product: 'Продукция',
    news: 'Новости и Ресурсы',
    about: 'О нас',
    contact: 'Контакты'
  },
  common: {
    welcome: 'Добро пожаловать'
  }
}